module.exports = __webpack_public_path__ + "static/images/gears.31fb738e9598f5a9478b3b5fd1a3a69d.svg";